module.exports = __webpack_public_path__ + "static/media/open-sans-bold.862115d3.woff2";